import { withTranslation } from '@application/i18n/with_translation';
import { DialogAlert } from '@cellula/react';
import { useResolve } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import { useEffect } from 'react';
import { IdentitySessionController } from './_identity_session.controller';

interface IdentitySessionWarningProps {
	beforeSignOut?: () => Promise<void>;
}
export function IdentitySessionWarning({ beforeSignOut }: IdentitySessionWarningProps) {
	const controller = useResolve(IdentitySessionController);
	useEffect(() => {
		controller.setBeforeSignOutCallback(beforeSignOut);

		return () => {
			controller.setBeforeSignOutCallback(undefined);
		};
	}, [controller, beforeSignOut]);
	const { needsTouch } = usePresentation(controller.state);

	function handleTouchClick() {
		controller.touchSession();
	}

	function handleSignOut() {
		controller.signOut();
	}

	return (
		<DialogAlert
			isOpen={needsTouch}
			header={withTranslation('View.AnonymousChat.Dialog.InactiveSession.Header')}
			description={withTranslation('View.AnonymousChat.Dialog.InactiveSession.Description')}
			abortText={withTranslation('View.AnonymousChat.Dialog.InactiveSession.Button.AbortText')}
			successText={withTranslation('View.AnonymousChat.Dialog.InactiveSession.Button.SuccessText')}
			successButtonVariant='primary'
			onSuccess={handleTouchClick}
			onAbort={handleSignOut}
		/>
	);
}
